import { createFileRoute } from '@tanstack/react-router';
import { toast } from '@/lib/toast';
import { Button } from '@worldcoo/ui/components/button';

export const Route = createFileRoute('/www/.internal/toast')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="relative flex flex-col gap-8 overflow-y-auto p-8">
			<div className="mx-auto w-full max-w-2xl space-y-12">
				<h1 className="text-2xl font-bold">Internal Demos</h1>
				<ToastDemo />
			</div>
		</div>
	);
}

// MARK: Toast Demo

function ToastDemo() {
	return (
		<section className="space-y-6">
			<div>
				<h2 className="text-xl font-semibold">Toasts</h2>
				<p className="text-muted-foreground mt-1 text-sm">All toast variants with pill icons.</p>
			</div>

			<div className="space-y-4 rounded-lg border p-4">
				<h3 className="text-sm font-semibold">Variants</h3>
				<div className="flex flex-wrap gap-3">
					<Button
						variant="outline"
						onClick={() => toast('Default toast', { description: 'This is a default notification.' })}
					>
						Default
					</Button>
					<Button
						variant="outline"
						onClick={() => toast.success('Success', { description: 'Operation completed successfully.' })}
					>
						Success
					</Button>
					<Button
						variant="outline"
						onClick={() => toast.error('Error', { description: 'Something went wrong. Please try again.' })}
					>
						Error
					</Button>
					<Button
						variant="outline"
						onClick={() => toast.warning('Warning', { description: 'This action may have unintended consequences.' })}
					>
						Warning
					</Button>
					<Button
						variant="outline"
						onClick={() => toast.info('Info', { description: 'Here is some useful information.' })}
					>
						Info
					</Button>
					<Button
						variant="outline"
						onClick={() => toast.loading('Loading', { description: 'Please wait while we process your request...' })}
					>
						Loading
					</Button>
				</div>
			</div>

			<div className="space-y-4 rounded-lg border p-4">
				<h3 className="text-sm font-semibold">Title Only</h3>
				<div className="flex flex-wrap gap-3">
					<Button variant="outline" onClick={() => toast('Default notification')}>
						Default
					</Button>
					<Button variant="outline" onClick={() => toast.success('Changes saved')}>
						Success
					</Button>
					<Button variant="outline" onClick={() => toast.error('Failed to save')}>
						Error
					</Button>
					<Button variant="outline" onClick={() => toast.warning('Unsaved changes')}>
						Warning
					</Button>
					<Button variant="outline" onClick={() => toast.info('New version available')}>
						Info
					</Button>
				</div>
			</div>

			<div className="space-y-4 rounded-lg border p-4">
				<h3 className="text-sm font-semibold">With Actions</h3>
				<div className="flex flex-wrap gap-3">
					<Button
						variant="outline"
						onClick={() =>
							toast.success('Item deleted', {
								description: 'The item has been removed.',
								action: { label: 'Undo', onClick: () => toast.info('Undone!') },
							})
						}
					>
						With Action
					</Button>
					<Button
						variant="outline"
						onClick={() =>
							toast.error('Connection lost', {
								description: 'Unable to reach the server.',
								action: { label: 'Retry', onClick: () => toast.loading('Reconnecting...') },
								cancel: { label: 'Dismiss', onClick: () => {} },
							})
						}
					>
						Action + Cancel
					</Button>
				</div>
			</div>

			<div className="space-y-4 rounded-lg border p-4">
				<h3 className="text-sm font-semibold">Promise</h3>
				<div className="flex flex-wrap gap-3">
					<Button
						variant="outline"
						onClick={() =>
							toast.promise(new Promise((resolve) => setTimeout(resolve, 2000)), {
								loading: 'Saving changes...',
								success: 'Changes saved!',
								error: 'Failed to save.',
							})
						}
					>
						Promise (resolves)
					</Button>
					<Button
						variant="outline"
						onClick={() =>
							toast.promise(new Promise((_, reject) => setTimeout(() => reject(new Error('fail')), 2000)), {
								loading: 'Uploading file...',
								success: 'Uploaded!',
								error: 'Upload failed.',
							})
						}
					>
						Promise (rejects)
					</Button>
				</div>
			</div>

			<div className="space-y-4 rounded-lg border p-4">
				<h3 className="text-sm font-semibold">Stress Test</h3>
				<div className="flex flex-wrap gap-3">
					<Button
						variant="outline"
						onClick={() => {
							toast.success('Success toast');
							toast.error('Error toast');
							toast.warning('Warning toast');
							toast.info('Info toast');
							toast('Default toast');
						}}
					>
						Fire All at Once
					</Button>
					<Button variant="outline" onClick={() => toast.dismiss()}>
						Dismiss All
					</Button>
				</div>
			</div>
		</section>
	);
}
